const shopContent = {
  computed: {
    shopContentRef() {
      return this.$refs && this.$refs.shopContent;
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$refs.shopContent.$getCenter().equal) {
      next();
    } else {
      setTimeout(() => {
        this.$confirm('您已修改门店坐标，是否确认保存？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          customClass: 'confirm',
          distinguishCancelAndClose: true,
          center: true
        })
          .then(() => {
            this.shopContentRef.onSave();
            return false;
          })
          .catch(action => {
            if (action == 'cancel') {
              next();
            }
          });
      }, 0);
    }
  }
};

export default shopContent;
